/**
 * Stan i handlery poppera filtra w nagłówku kolumny (ikona filtra).
 * Zamyka popper przy wyłączeniu ikon filtrów.
 */
import { useState, useCallback, useEffect } from 'react';

export function useColumnFilterPopper(showColumnFilterIcons: boolean) {
  const [columnFilterPopperOpen, setColumnFilterPopperOpen] = useState(false);
  const [columnFilterPopperColumnId, setColumnFilterPopperColumnId] = useState<string | null>(null);
  const [columnFilterPopperAnchorEl, setColumnFilterPopperAnchorEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!showColumnFilterIcons) {
      setColumnFilterPopperColumnId(null);
      setColumnFilterPopperAnchorEl(null);
      setColumnFilterPopperOpen(false);
    }
  }, [showColumnFilterIcons]);

  const onOpenColumnFilterDialog = useCallback((columnId: string, anchorEl: HTMLElement | null) => {
    setColumnFilterPopperColumnId(columnId);
    setColumnFilterPopperAnchorEl(anchorEl);
    setColumnFilterPopperOpen(true);
  }, []);

  const onCloseColumnFilterDialog = useCallback(() => {
    setColumnFilterPopperOpen(false);
    setColumnFilterPopperColumnId(null);
    setColumnFilterPopperAnchorEl(null);
  }, []);

  return {
    columnFilterPopperOpen,
    columnFilterPopperColumnId,
    columnFilterPopperAnchorEl,
    onOpenColumnFilterDialog,
    onCloseColumnFilterDialog
  };
}
